import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../Utils/Axios';
import DashboardHeader from '../CompanyComponents/DashboardHeaderRouter';
import LoadingScreen from '../../Components/LoadingScreen';
import AkhrajatBook from './AkhrajatBook';
import { useBackspaceNavigation } from '../../hooks/useBackspaceNavigation';

function AkhrajatBookP2Wrapper() {
  const navigate = useNavigate();
  
  // Backspace navigation to dashboard
  useBackspaceNavigation();
  
  const [company, setCompany] = useState(null);
  const [companyLanguage, setCompanyLanguage] = useState('ur');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchCompanyProfile();
  }, []);

  const getToken = () => localStorage.getItem('companyToken');

  const fetchCompanyProfile = async () => {
    try {
      setIsLoading(true);
      const token = getToken();
      if (!token) {
        navigate('/company/login');
        return;
      }

      const response = await api.get('/company/profile', {
        headers: { Authorization: `Bearer ${token}` }
      });

      const companyData = response.data.company;
      setCompany(companyData);
      const lang = companyData?.websiteLanguage || companyData?.language || 'ur';
      setCompanyLanguage(lang);
      localStorage.setItem('companyLanguage', lang);
    } catch (error) {
      console.error('Fetch company error:', error);
      const lang = companyLanguage || localStorage.getItem('companyLanguage') || 'ur';
      const errorMessage = error.response?.status === 500 
        ? (lang === 'ur' ? 'کمپنی ڈیٹا لوڈ کرنے میں خرابی' : 'Error loading company data')
        : (lang === 'ur' ? 'کمپنی ڈیٹا لوڈ نہیں ہو سکا' : 'Failed to load company data');
      toast.error(errorMessage, { autoClose: 3000 });
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('companyToken');
    localStorage.removeItem('companyData');
    navigate('/company/login');
    toast.info(companyLanguage === 'ur' ? 'کامیابی سے لاگ آؤٹ ہو گئے' : 'Logged out successfully');
  };

  const getPagePermission = (pageKey) => {
    if (!company?.pagePermissions) return true;
    const permissions = company.pagePermissions instanceof Map
      ? Object.fromEntries(company.pagePermissions)
      : company.pagePermissions;
    return permissions[pageKey] !== false;
  };

  const hasAccess = getPagePermission('akhrajat-book-p2');

  if (isLoading) {
    return (
      <LoadingScreen
        companyLanguage={companyLanguage}
        message={companyLanguage === "ur" ? "لوڈ ہو رہا ہے..." : "Loading..."}
      />
    );
  }

  if (!hasAccess) {
    navigate('/company/dashboard-part2');
    toast.error(companyLanguage === 'ur' ? 'آپ کو اس صفحے تک رسائی نہیں ہے' : 'You do not have access to this page');
    return null;
  }

  return (
    <>
      <DashboardHeader
        companyLanguage={companyLanguage}
        onLogout={handleLogout}
        company={company}
        setActiveTab={() => {}}
        activeTab="overview"
      />
      <AkhrajatBook companyLanguage={companyLanguage} company={company} />
    </>
  );
}

export default AkhrajatBookP2Wrapper;


